import { t } from "@lingui/macro";
import { cn } from "@reactive-resume/utils";
import { useMemo } from "react";
import { Link, matchRoutes, Outlet, useLocation } from "react-router-dom";

import { useAuthProviders } from "@/client/services/auth/providers";

import { SocialAuth } from "./_components/social-auth";

const authRoutes = [{ path: "/auth/login" }, { path: "/auth/register" }];

export const AuthLayout = () => {
  const location = useLocation();
  const { providers } = useAuthProviders();
  const isAuthRoute = useMemo(() => matchRoutes(authRoutes, location) !== null, [location]);

  if (!providers) return null;

  const hideDivider = !providers.includes("email") || providers.length === 1;

  return (
    <div className="flex h-screen w-screen items-center justify-center bg-white px-16">
      {/* Outer wrapper with equal padding on both ends */}
      <div className="flex h-full w-full max-w-6xl items-center gap-16">
        {/* LEFT — image, takes all remaining space */}
        {/* LEFT — image, takes all remaining space */}
        <div className="hidden lg:flex lg:flex-1 items-center justify-center -ml-16">
          <img
            width={1920}
            height={1080}
            alt="Open books on a table"
            className="h-full w-full object-contain object-center"
            src="/loginimage2.png"
          />
        </div>

        {/* RIGHT — fixed width so inputs don't stretch */}
        <div className="flex w-full max-w-[380px] flex-col justify-center gap-y-4">
          <div className="flex items-center">
            <Link to="/" className="size-24">
              <h1 className="flex text-[30px] font-bold text-primary">
                <img src="/icon/logo-jobprep.png" alt="logo" className="mt-[-10px] size-9" />
                {t`obPrep`}
              </h1>
            </Link>
          </div>

          <Outlet />

          {isAuthRoute && (
            <>
              <div className={cn("flex items-center gap-x-4", hideDivider && "hidden")}>
                <hr className="flex-1" />
                <span className="text-xs font-medium">
                  {t({
                    message: "or continue with",
                    context:
                      "The user can either login with email/password, or continue with GitHub or Google.",
                  })}
                </span>
                <hr className="flex-1" />
              </div>
              <SocialAuth />
            </>
          )}
        </div>
      </div>
    </div>
  );
};
